import { Info } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import React from 'react';

interface InfoTooltipProps {
    message: string;
}

const InfoTooltip: React.FC<InfoTooltipProps> = ({ message }) => {
    return (
        <Tooltip title={message} sx={{ml:1}}>
            <Info fontSize="small" color="secondary" data-testid="InfoIcon"/>
        </Tooltip>
    );
};

export default InfoTooltip;